// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"3d5d9d30","704":"4cebcf48","787":"fb83d561"}[chunkId] + ".chunk.js";
};